import React from "react";
import Link from "../../common/components/Link";

const Operations = (props) => {
	const storeBaseUrl = ISites.Configurations.ExternalSites.ISellFrontEnd.Url
		? ISites.Configurations.ExternalSites.ISellFrontEnd.Url
		: "";
	const hpBaseUrl = ISites.Configurations.Site.Url.SiteAbsoluteUrl
		? ISites.Configurations.Site.Url.SiteAbsoluteUrl
		: "";
	return (
		<ul className="hyperlinks">
			<li>
				<Link
					href={`${storeBaseUrl}/carrinho`}
					className="btn-fill btn-tiny btn-gray btn-txt-white icon-seta-right btn-icon-right"
					text="Carrinho"
				/>
			</li>
			<li>
				<Link
					href={`${hpBaseUrl}/loja`}
					className="btn-txt btn-tiny btn-txt-black icon-seta-right btn-icon-right"
					text="Loja Online"
				/>
			</li>
		</ul>
	);
};

export default Operations;
